export default "__VITE_ASSET__JAkJQAL3__"